import { SetStateAction, atom } from "jotai";
import { atomFamily } from "jotai/utils";
import merge from "lodash.merge";
import { DeepPartial } from "typeUtils";

import { ClientConfig, DEFAULT_CLIENT_CONFIG } from "app/clientConfig";

import { clientIdAtom } from "./clientId";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionClientConfigAtom = atomFamily((clientId: string) =>
  createPersistedAtom<ClientConfig>(`clientConfig-${clientId}`, DEFAULT_CLIENT_CONFIG)
);

export const clientConfigAtom = atom(
  (get) => get(sessionClientConfigAtom(get(clientIdAtom))),
  (get, set, update: SetStateAction<ClientConfig>) => set(sessionClientConfigAtom(get(clientIdAtom)), update)
);

export const createConfigFromBaseAtom = atom<null, DeepPartial<ClientConfig>>(null, (_get, set, update) =>
  set(clientConfigAtom, merge({}, DEFAULT_CLIENT_CONFIG, update))
);

export const themeConfigAtom = atom((get) => get(clientConfigAtom).theme);
